import { render, staticRenderFns } from "./NetworkUsageTab.vue?vue&type=template&id=3551fec3&"
import script from "./NetworkUsageTab.vue?vue&type=script&lang=js&"
export * from "./NetworkUsageTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports